//? polyfill fetch since browser apis are not ECMAScript, they aren't included in core-js polyfills
import "whatwg-fetch";
import { browser } from "./stores";
import App from "./App.svelte";

const app = new App({
  target: document.getElementById("reports-app"),
  props: {},
});

// add class to page body
document.querySelector("html").classList.add("reports-app-loaded");

// svelte-routing does not move scroll position to top when linking pages
// this hack will take care of that for us
if (browser.name !== "ie") {
  history.pushState = new Proxy(history.pushState, {
    apply(target, thisArg, argumentsList) {
      Reflect.apply(target, thisArg, argumentsList);
      if (argumentsList[2].indexOf("?") !== 0) scrollTo(0, 0);
    },
  });
}

export default app;
